<ng-content select="[show-more-heading]"></ng-content>
<a *ngIf="!toggled" class="link nowrap" (click)="toggle()"> Rozwiń<app-icon name="expand_more" [height]="12" [width]="12"></app-icon>
</a>
<a *ngIf="toggled" class="link nowrap" (click)="toggle()"> Zwiń<app-icon name="expand_less" [height]="12" [width]="12"></app-icon>
</a>
<ng-content *ngIf="toggled" select="[show-more-body]"></ng-content>
